// extracted by mini-css-extract-plugin
export default {"labelType":"styles_labelType__xcLfx","columnStyles":"styles_columnStyles__uMi24","downArrowButton":"styles_downArrowButton__67cVS","rotated":"styles_rotated__sZz4d"};